function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { colors } from '../../theme';
import { fonts } from '../../theme';
import { createOwnUpStyle } from '../style';
export var OwnUpButtonStyle = createOwnUpStyle(_objectSpread(_objectSpread({}, fonts.GRAPHIK_MEDIUM), {}, {
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '15px',
  cursor: 'pointer',
  color: colors.WHITE,
  backgroundColor: colors.PRIMARY,
  textAlign: 'center',
  letterSpacing: '2px',
  height: '52px',
  minWidth: '315px',
  border: 'none',
  borderRadius: '100px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  // Necessary to fix baseline
  paddingTop: '0.3em',
  '& svg': {
    margin: '0 5px 0 0',
    stroke: colors.WHITE,
    fill: colors.WHITE
  },
  '&[disabled]': {
    background: colors.PRIMARY_DISABLED,
    cursor: 'unset'
  },
  variants: {
    alt: {
      minWidth: '300px',
      fontSize: '13px',
      color: colors.PRIMARY_ALT,
      backgroundColor: 'transparent',
      height: '41px',
      border: "2px solid ".concat(colors.PRIMARY_ALT),
      '& svg': {
        stroke: colors.PRIMARY_ALT,
        fill: colors.PRIMARY_ALT
      },
      '&[disabled]': {
        color: colors.PRIMARY_DISABLED,
        borderColor: colors.PRIMARY_DISABLED,
        cursor: 'unset',
        '& > svg': {
          stroke: colors.PRIMARY_DISABLED,
          fill: colors.PRIMARY_DISABLED
        }
      }
    },
    lightAlt: {
      color: colors.PRIMARY,
      border: "1px solid ".concat(colors.PRIMARY_ALT),
      backgroundColor: 'transparent',
      '& svg': {
        stroke: colors.PRIMARY,
        fill: colors.PRIMARY
      },
      '&[disabled]': {
        color: colors.PRIMARY_DISABLED,
        borderColor: colors.PRIMARY_DISABLED,
        cursor: 'unset'
      }
    },
    header: _objectSpread(_objectSpread({}, fonts.GRAPHIK_REGULAR), {}, {
      color: colors.WHITE,
      fontWeight: 500,
      fontSize: '12px',
      backgroundColor: 'transparent',
      border: "1px solid ".concat(colors.WHITE),
      textTransform: 'unset',
      letterSpacing: '0.3px',
      minWidth: '68px',
      height: '30px',
      '& svg': {
        stroke: colors.WHITE,
        fill: colors.WHITE
      },
      // Necessary to fix baseline
      paddingTop: '0.1em',
      variants: {
        smallAndUp: {
          minWidth: '138px'
        }
      }
    }),
    headerAlt: {
      color: colors.PRIMARY_ALT,
      border: "1px solid ".concat(colors.GREY),
      '& span': {
        marginRight: '5px'
      },
      '& svg': {
        stroke: colors.PRIMARY_ALT,
        fill: colors.PRIMARY_ALT
      }
    },
    square: {
      fontSize: '14px',
      height: '49px',
      letterSpacing: 'unset',
      textTransform: 'unset',
      fontWeight: 'unset',
      minWidth: 'unset',
      borderRadius: '3px',
      padding: '0.3em 22px',
      '& svg': {
        margin: '0 8px 0 0'
      }
    },
    heroic: _objectSpread(_objectSpread({}, fonts.GRAPHIK_REGULAR), {}, {
      textTransform: 'capitalize',
      fontSize: '15px',
      height: '56px',
      lineHeight: '32px',
      minWidth: '152px',
      letterSpacing: '0.5px',
      color: colors.WHITE,
      background: colors.BLUE,
      margin: '7.5px 5.5px',
      transition: 'background 300ms ease-in-out',
      '& svg': {
        stroke: colors.WHITE,
        fill: colors.WHITE
      },
      '&[disabled]': {
        background: colors.GREY,
        cursor: 'unset'
      },
      '&:hover': {
        background: colors.BLUE_ALT,
        '&:disabled': {
          background: colors.GREY
        }
      },
      variants: {
        smallAndDown: {
          width: '100%'
        },
        alt: {
          background: 'transparent',
          color: colors.PRIMARY_ALT,
          border: "1px solid ".concat(colors.GREY),
          height: '56px',
          transition: 'border-color 300ms ease-in-out',
          '& > svg': {
            stroke: colors.PRIMARY_ALT,
            fill: colors.PRIMARY_ALT
          },
          '&:hover': {
            background: 'transparent',
            borderColor: colors.PRIMARY_DISABLED
          }
        }
      }
    }),
    socialButton: {
      fontSize: '15px',
      fontWeight: 300,
      letterSpacing: '.1px',
      cursor: 'pointer',
      alignItems: 'center',
      backgroundColor: colors.WHITE,
      border: ".5px solid ".concat(colors.GREY),
      borderRadius: '4px',
      color: colors.PRIMARY,
      display: 'flex',
      textTransform: 'none',
      width: '225px',
      height: '56px',
      '&[disabled]': {
        color: colors.PRIMARY_DISABLED,
        backgroundColor: colors.BACKGROUND,
        cursor: 'not-allowed'
      },
      ':hover': {
        border: "1px solid ".concat(colors.PRIMARY_DISABLED),
        '&:disabled': {
          border: ".5px solid ".concat(colors.GREY)
        }
      }
    },
    linkButton: {
      fontSize: '15px',
      fontWeight: 300,
      letterSpacing: '.1px',
      cursor: 'pointer',
      alignItems: 'center',
      backgroundColor: colors.WHITE,
      border: '.5px solid #DBE1E1',
      borderRadius: '4px',
      color: colors.PRIMARY,
      display: 'flex',
      textTransform: 'none',
      minWidth: 0,
      width: 'fit-content',
      height: '56px',
      ':hover': {
        border: '1px solid #B2C1C0'
      }
    }
  }
}));